import React from "react";

export function IdentificationCertificate({
  fullName,
  fatherName,
  aadharNo,
  panNo,
}: {
  fullName: string;
  fatherName?: string;
  aadharNo?: string;
  panNo?: string;
}) {
  return (
    <div className="ea-idcert">
      <div className="ea-idcert-head">
        <strong>IDENTIFICATION CERTIFICATE:</strong>
        <span>(Certificate to be signed by any one of the following)</span>
      </div>
      <ul className="ea-idcert-list">
        <li>(i) Gazetted officers Central or State Government.:</li>
        <li>
          (ii) Members of the Parliament of state legislature belonging to the constituency where
          the candidate or his parent/guardian is ordinary resident:
        </li>
        <li>(iii) Sub-Divisional Magistrates/Officers:</li>
        <li>
          (iv) Tehsildar or Naib/Deputy Tehsildar authorised to exercise magisterial powers:
        </li>
        <li>
          (v) Principal/Headmasters of the recognized school/college institution where the
          candidate studied last:
        </li>
        <li>(vi) Block Development Officers:</li>
        <li>(vii) Panchayat Inspector (viii) PostMaster:</li>
      </ul>
      <div className="ea-idcert-meta">
        <div>Your Aadhar No: {aadharNo || ""}</div>
        <div>Your PAN No: {panNo || ""}</div>
      </div>
      <div className="ea-idcert-cert">
        <div>
          Certified that I have known Shri/Smt/Kumari: <strong>{fullName || ""}</strong>
        </div>
        <div>
          Son/Daughter of Shri <strong>{fatherName || ""}</strong> For the last:
        </div>
        <div>Years Months and that to the best of my knowledge:</div>
        <div>and belief the particulars furnished by him/her are correct.:</div>
      </div>
      <div className="ea-idcert-sign">
        <div>Date:</div>
        <div>Signature:</div>
        <div>Place:</div>
        <div>Designation or status and address:</div>
      </div>
      <div className="ea-idcert-office">( TO BE FILLED BY THE OFFICE )</div>
      <div className="ea-idcert-office-fields">
        <div>Name, designation and full address of the appointing authority:</div>
        <div>Post for which candidate is being considered:</div>
      </div>
      <style>{`
        .ea-idcert { background: #f4f8fb; border: 1px solid #c5d8e8; padding: 18px 20px 8px; margin-bottom: 24px; border-radius: 4px; }
        .ea-idcert-head { text-align: right; margin-bottom: 12px; }
        .ea-idcert-head strong { display: block; letter-spacing: 0.04em; }
        .ea-idcert-head span { font-size: 13px; color: #334155; }
        .ea-idcert-list { list-style: none; padding: 0; margin: 0 0 18px; font-size: 14px; line-height: 1.7; color: #1e293b; }
        .ea-idcert-meta { font-size: 14px; margin-bottom: 16px; }
        .ea-idcert-cert { font-size: 14px; line-height: 1.8; margin-bottom: 28px; }
        .ea-idcert-sign { display: grid; grid-template-columns: 1fr 1fr; gap: 28px 40px; font-size: 14px; margin-bottom: 28px; }
        .ea-idcert-office { text-align: center; font-weight: 600; margin: 8px 0 16px; }
        .ea-idcert-office-fields { font-size: 14px; line-height: 1.9; padding-bottom: 8px; }
        @media (max-width: 767px) {
          .ea-idcert-head { text-align: left; }
          .ea-idcert-sign { grid-template-columns: 1fr; gap: 12px; }
        }
      `}</style>
    </div>
  );
}
